
import PropTypes from 'prop-types'
import React from 'react'
import highlight from './highlight'
import './Snippet.css'

const types = [
  'javascript',
  'bash',
  'c',
  'c-sharp',
  'ruby',
  'java',
  'php',
  'python',
  'objective-c',
  'go',
  'sql'
]

const Snippet = props => {
  const { children, language } = props
  let code = children
  // this is here to support rendering both React components and text
  if (Array.isArray(children)) {
    code = children.join('')
  }
  const lineNumbers = code.split('\n').map((_, i) => i + 1).join('\n')
  const html = highlight.string(code, language)

  return (
    <div className='Snippet'>
      <div className='Snippet-gutter'>{lineNumbers}</div>
      <code className='Snippet-code' dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  )
}

Snippet.defaultProps = {
  language: types[0]
}

Snippet.displayName = 'Snippet'

Snippet.propTypes = {
  children: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired
}

export default Snippet



// WEBPACK FOOTER //
// ./ui/Snippet.js